import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const { userInfo } = useSelector((state) => state.user);

  if (!userInfo?.isAdmin) {
    return <Navigate to='/dashboard' replace />;
  }

  return children;
};

export default AdminRoute;
